// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerClassName_ebFA_ {
  border-bottom: 0px;
}

.pendingSaleMessageQuestionContent_DAFJr {
  height: 300px !important;
  min-height: 300px !important;
}

.pendingSaleMessageContent_rXosz {
  height: 755px !important;
  min-height: 755px !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/flows/BulkVehicleOnly.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B","sourcesContent":[".headerClassName {\n  border-bottom: 0px;\n}\n\n.pendingSaleMessageQuestionContent {\n  height: 300px !important;\n  min-height: 300px !important;\n}\n\n.pendingSaleMessageContent {\n  height: 755px !important;\n  min-height: 755px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerClassName": `headerClassName_ebFA_`,
	"pendingSaleMessageQuestionContent": `pendingSaleMessageQuestionContent_DAFJr`,
	"pendingSaleMessageContent": `pendingSaleMessageContent_rXosz`
};
export default ___CSS_LOADER_EXPORT___;
